<template>
  <div>
    <div class="output-group">
      <div class="output-title"><b>Dados do Segurado</b></div>
      <div><span>Nome:</span>{{ objDTO.SeguradoContacto.Nome }}</div>
      <div><span>CPF/CNPJ:</span>{{ cpfCnpj() }}</div>
      <div><span>RG:</span> {{ objDTO.SeguradoContacto.nrID }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    objDTO: Object,
  },
  methods: {
    cpfCnpj() {
      if (
        this.objDTO.SeguradoContacto.NrContribuinte.replace(/[^\d]/g, "")
          .length == 11
      ) {
        return this.objDTO.SeguradoContacto.NrContribuinte.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );
      } else {
        return this.objDTO.SeguradoContacto.NrContribuinte.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    },
  },
};
</script>
